export type FactSetOAuthConnectOutcome =
  | "already_connected"
  | "connected"
  | "dismissed"
  | "unavailable"
  | "failed";

export interface FactSetOAuthConnectResult {
  outcome: FactSetOAuthConnectOutcome;
  error?: string;
}

export interface AuthHostServices {
  setUserScope?: (userId: string | null | undefined) => void;
  initFeatureFlags?: (
    userEmail: string,
    options?: {
      sdkKey?: string;
      accountScopeKey?: string | null;
      companyId?: string | null;
    }
  ) => Promise<void> | void;
  disposeFeatureFlags?: () => void;
  ensureFactSetOAuthConnected?: () => Promise<FactSetOAuthConnectResult>;
}

let registeredServices: AuthHostServices = {};

export function registerAuthHostServices(services: AuthHostServices): void {
  registeredServices = { ...registeredServices, ...services };
}

export function getAuthHostServices(): AuthHostServices {
  return registeredServices;
}
